import { useCallback } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UITextToolbarIconDropdown from 'rich-text-lib/components/editor/UITextToolbarIconDropdown';
import { AlignLeftIcon, AlignCenterIcon, AlignJustifyIcon, AlignRightIcon } from 'foundations-assets';
import useDebouncedEditorStateContext from '../contexts/useDebouncedEditorStateContext';
import { ImageFocusPlugin } from '../plugins/ImageFocusPlugin';
import { CHANGE_INLINE_STYLE } from 'rich-text-lib/constants/usageTracking';
import { Tracker } from '../../utils/usageTracker';
import { PM_FORMATTING } from '../constants/events';
import { jsx as _jsx } from "react/jsx-runtime";
export default function TextAlignment() {
  const {
    editorState,
    setEditorState
  } = useDebouncedEditorStateContext();
  const setAlignmentMark = useCallback(evt => {
    const tr = editorState.tr;
    const pluginState = ImageFocusPlugin.getState(editorState);
    if (pluginState && pluginState.imagePos) {
      const imageNode = editorState.doc.resolve(pluginState.imagePos).nodeAfter;
      if (imageNode) {
        const newAttrs = Object.assign({}, imageNode.attrs);
        newAttrs.align = evt.target.value;
        tr.setNodeMarkup(pluginState.imagePos, undefined, newAttrs);
      }
    } else {
      editorState.doc.nodesBetween(editorState.selection.from, editorState.selection.to, (node, pos) => {
        if (node.type.spec.attrs && node.type.spec.attrs.align) {
          const newAttrs = Object.assign({}, node.attrs);
          newAttrs.align = evt.target.value;
          tr.setNodeMarkup(pos, node.type, newAttrs);
        }
      });
    }
    setEditorState(editorState.apply(tr));
    Tracker.track(PM_FORMATTING, {
      action: CHANGE_INLINE_STYLE,
      method: 'toolbar',
      value: `align-${evt.target.value.toLowerCase()}`
    });
  }, [editorState, setEditorState]);
  return /*#__PURE__*/_jsx(UITextToolbarIconDropdown, {
    options: [{
      icon: 'alignLeft',
      Icon: AlignLeftIcon,
      value: 'left',
      // @ts-expect-error not in types
      'data-test-id': 'align-left'
    }, {
      icon: 'alignCenter',
      Icon: AlignCenterIcon,
      value: 'center',
      'data-test-id': 'align-center'
    }, {
      icon: 'alignJustify',
      Icon: AlignJustifyIcon,
      value: 'justify',
      'data-test-id': 'align-justify'
    }, {
      icon: 'alignRight',
      Icon: AlignRightIcon,
      value: 'right',
      'data-test-id': 'align-right'
    }],
    "data-test-id": "block-alignment-dropdown",
    onChange: setAlignmentMark,
    defaultValue: "left",
    tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "hubspot-prosemirror.tooltips.textAlignment"
    })
  });
}